import { useEffect } from "react";
import api from "../../lib/api";

const CLR = ["background", "foreground", "primary", "secondary", "accent"];
const SERIF_FALLBACK = "Georgia, serif";
const SANS_FALLBACK = "system-ui, sans-serif";

function parseHsl(str) {
  const [h, s, l] = String(str || "").replace(/%/g, "").split(/\s+/).map(Number);
  return { h: h || 0, s: s || 0, l: l || 0 };
}
const clamp = (n) => Math.max(0, Math.min(100, Math.round(n)));
const hsl = (h, s, l) => `${h} ${clamp(s)}% ${clamp(l)}%`;

export function applyThemeVars(theme) {
  if (!theme) return;
  const root = document.documentElement;
  CLR.forEach((k) => { if (theme[k]) root.style.setProperty(`--${k}`, theme[k]); });

  // Derive surface tokens from the background lightness so dark themes stay cohesive.
  if (theme.background) {
    const bg = parseHsl(theme.background);
    const fg = parseHsl(theme.foreground || "0 0% 15%");
    const dark = bg.l < 50;
    const card = hsl(bg.h, bg.s, dark ? bg.l + 6 : bg.l - 3);
    const popover = hsl(bg.h, bg.s, dark ? bg.l + 8 : bg.l - 2);
    const muted = hsl(bg.h, Math.max(bg.s - 8, 0), dark ? bg.l + 12 : bg.l - 6);
    const border = hsl(bg.h, Math.max(bg.s - 4, 0), dark ? bg.l + 18 : bg.l - 13);
    root.style.setProperty("--card", card);
    root.style.setProperty("--popover", popover);
    root.style.setProperty("--muted", muted);
    root.style.setProperty("--border", border);
    root.style.setProperty("--input", border);
    root.style.setProperty("--card-foreground", theme.foreground || "145 25% 15%");
    root.style.setProperty("--popover-foreground", theme.foreground || "145 25% 15%");
    root.style.setProperty("--accent-foreground", theme.foreground || "145 25% 15%");
    root.style.setProperty("--muted-foreground", hsl(fg.h, 12, dark ? 62 : 42));
  }

  // Contrast-aware foregrounds so light primary/secondary (e.g. yellow) get dark text.
  const light = "45 30% 98%", ink = "145 25% 15%";
  if (theme.primary) root.style.setProperty("--primary-foreground", parseHsl(theme.primary).l >= 60 ? ink : light);
  if (theme.secondary) root.style.setProperty("--secondary-foreground", parseHsl(theme.secondary).l >= 60 ? ink : light);

  if (theme.font_heading) root.style.setProperty("--font-display", `'${theme.font_heading}', ${SERIF_FALLBACK}`);
  if (theme.font_body) root.style.setProperty("--font-body", `'${theme.font_body}', ${SANS_FALLBACK}`);
}

export default function ThemeApplier() {
  useEffect(() => {
    api.get("/theme").then((r) => applyThemeVars(r.data)).catch(() => {});
  }, []);
  return null;
}
